<!-- eslint-disable-next-line agentic/no-single-template-wrapper -->
<div class="wrapper">
    <div class="visual">
        @if (image(); as stateImage) {
            <img
                class="image"
                loading="eager"
                [ngSrc]="stateImage.src"
                [attr.srcset]="stateImage.srcset ?? null"
                [alt]="stateImage.alt"
                [height]="stateImage.height"
                [width]="stateImage.width"
                [placeholder]="stateImage.placeholder ?? false"
                disableOptimizedSrcset
            />
        } @else {
            <ng-icon
                qpx
                size="lg"
                [name]="iconName()"
                context="secondary"
                tone="muted"
            />
        }
    </div>

    <div class="content">
        @if (headingLevel() === 2) {
            <h2 qpxModalTitle class="title">{{ heading() }}</h2>
        } @else {
            <h3 qpxModalTitle class="title">{{ heading() }}</h3>
        }

        <p qpxBody="secondary" tone="muted" class="description">
            <ng-content select="[description]" />
        </p>

        <ng-content select="[action]" />
    </div>
</div>
